<template>
  <div class="orders_i main-container">
       <div class="contain hidden-sm-and-down">
          <div class="Xcontainer">
            <h4>
              <router-link :to="{ name:'Information', query: {id: 'orderslist'} }" >&lt;&lt;返回订单列表</router-link>
            </h4>
            <div class="ok">
              <img src="../assets/ok.png" alt="">
              <div>
                <h4>
                  交易状态:  {{ordersDetail}}
                </h4>
                <span>下单时间:&nbsp;&nbsp;{{ordersTime}}</span>
                <span>订单编号:&nbsp;&nbsp;{{ordersNum}}</span>
              </div>
            </div>
            <div class="orderdata" v-if="this.ordersData.order_status!=4">
              <table>
                <tr>
                  <td>收件人姓名</td>
                  <td>:&nbsp;&nbsp;</td>
                  <td>{{name}}</td>
                </tr>
                <tr>
                  <td>联系电话</td>
                  <td>:&nbsp;&nbsp;</td>
                  <td>{{phone}}</td>
                </tr>
                <tr>
                  <td>配送地址</td>
                  <td>:&nbsp;&nbsp;</td>
                  <td>{{address}}</td>
                </tr>
                <tr v-if="this.postcode!=null">
                  <td>邮编</td>
                  <td>:&nbsp;&nbsp;</td>
                  <td>{{postcode}}</td>
                </tr>
                <tr>
                  <td>支付方式</td>
                  <td>:&nbsp;&nbsp;</td>
                  <td class="payment" v-if="this.ordersData.order_status==1">
                    <el-radio-group v-model="paymentRadio">
                      <el-radio :label="1"><img src="../assets/wx-min.png" alt="">微信</el-radio>
                      <!-- <el-radio :label="2"><img src="../assets/zfb-min.png" alt="">支付宝</el-radio> -->
                    </el-radio-group>
                  </td>
                  <td class="payment" v-if="this.ordersData.order_status!=1 && this.ordersData.order_status!=4">
                    {{payment}}
                  </td>
                </tr>
              </table>
            </div>
            <div class="orders">
              <h5>订单信息</h5>
              <div>
                <!--pc端显示-->
                <!-- <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" class="hidden-xs-only" @selection-change="handleSelectionChange"> -->
                <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" class="hidden-xs-only">
                  <!-- <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column> -->
                  <el-table-column label="">
                    <template slot-scope="scope"><span><img class="cover" :src="imgsrc+scope.row.cover" alt=""></span></template>
                  </el-table-column>
                  <el-table-column label="商品信息">
                    <template slot-scope="scope">
                      <span>{{scope.row.name}}</span>
                      <br/>
                      <span class="taocan">{{scope.row.specs.group}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="数量">
                    <template slot-scope="scope">{{scope.row.num}}</template>
                  </el-table-column>
                  <el-table-column label="单价">
                    <template slot-scope="scope"><span>￥{{(+ scope.row.specs.price).toFixed(2)}}</span></template>
                  </el-table-column>
                  <el-table-column label="总计">
                    <template slot-scope="scope"><span>￥{{ (scope.row.num*scope.row.specs.price).toFixed(2) }}</span></template>
                  </el-table-column>
                  <!-- <el-table-column
                    fixed="right"
                    label="操作"
                    width="120" v-if="ordersData.order_status==2 || ordersData.order_status==3">
                    <template slot-scope="scope">
                      <el-button
                        @click.native.prevent="Refund(scope.$index, tableData)"
                        type="text"
                        size="small">
                        申请退款
                      </el-button>
                    </template>
                  </el-table-column> -->
                </el-table>
                <!--pc端显示end-->
                <el-row>
                  <el-col :span="24">
                    <div class="submit_box">
                      <span v-if="this.ordersData.order_status==1" class="submit" @click="topay">去支付</span>
                      <p>
                        <span>共 <i>{{goodsNumber}}</i> 件商品</span>&nbsp;&nbsp;&nbsp;
                        <span>运费: ￥{{freight}}</span>&nbsp;&nbsp;&nbsp;
                        <span>总计: ￥<i>{{goodsPrice}}</i></span>&nbsp;&nbsp;&nbsp;
                        <el-button :disabled="RefundBtn" @click="Refund" v-if="ordersData.order_status==2 || (ordersData.order_status==3 && Date.parse(new Date())-Date.parse(ordersData.pay_time)<1296000000)">申请退款</el-button>
                      </p>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div v-html="alipay" style="height: 0; opacity: 0;"> {{ alipay }} </div>
            </div>
          </div>
       </div>


       <!-- 手机端显示 -->
    <div class="ordersmob hidden-md-and-up">
        <div class="citybox" v-if="this.ordersData.order_status!=4">
          <p>{{ address }} {{ name }} {{ phone }}</p>
       </div>
          <div v-for="(item,index) in tableData " :key="index">
            <div class="allorder">
            <div class="orderlft">
                <div>
                    <img :src="imgsrc + item.cover" alt="">
                </div>
                </div>
                <div class="orderrig">
                    <p>{{ item.name }}</p>
                    <p>￥{{ (+ item.specs.price).toFixed(2) }} <span style="float:right">总计￥{{ (item.num*item.specs.price).toFixed(2) }}</span></p>
                    <p>数量: {{ item.num }}</p>
                </div>
            </div>
            <div style="height:1px;background: rgba(0, 56, 63, 0.5);margin:0 0.3rem"></div>
        </div>
        <div class="payMethod">
            <h1>支付方式</h1>
            <p v-if="this.ordersData.order_status!=1 && this.ordersData.order_status!=4" style="display: flex;justify-content: space-between;align-items: center;"> 
              {{payment}}
              <el-button class="refund" :disabled="RefundBtn" @click="Refund" v-if="ordersData.order_status==2 || (ordersData.order_status==3 && Date.parse(new Date())-Date.parse(ordersData.pay_time)<1296000000)">申请退款</el-button>
            </p>
            <div class="payment" v-if="this.ordersData.order_status==1">
              <el-radio-group v-model="paymentRadio">
                <el-radio :label="1"><img style="width:0.32rem" src="../assets/wx-min.png" alt=""><span style="vertical-align: top;">微信</span></el-radio>
                <!-- <el-radio :label="2"><img style="width:0.32rem" src="../assets/zfb-min.png" alt=""><span style="vertical-align: top;">支付宝</span></el-radio> -->
              </el-radio-group>
            </div>
            
            <div style="height:1px;background: rgba(0, 56, 63, 0.5);margin:0 0.3rem"></div>
        </div>
          <div class="payMethod">
            <h1> 交易状态:  {{ordersDetail}}</h1>
              <p>下单时间: {{ordersTime}}</p>
              <p>订单编号: {{ordersNum}}</p>
            <div style="height:1px;background: rgba(0, 56, 63, 0.5);margin:0 0.3rem"></div>
        </div>
        <div class="orderbto" v-if="this.ordersData.order_status!=1">
          <p>共{{goodsNumber}}件商品 &nbsp; 运费:￥{{freight}} &nbsp; 总计:￥{{goodsPrice}}</p>
           <router-link :to="{ name:'Information', query: {id: 'orderslist'} }" >返回订单列表</router-link>
        </div>
        <div class="orderbtos"  v-if="this.ordersData.order_status==1" >
             <p>共{{goodsNumber}}件商品 &nbsp; 运费:￥{{freight}} &nbsp; 总计:￥{{goodsPrice}}</p>
             <span v-if="this.ordersData.order_status==1" class="submit" @click="topay">去支付</span>
        </div>
    </div>
  </div>
</template>

<script>
import { orders_i_url,payOrder_url,order_refund } from '../request/api'
  export default {
    name: "ordersOk",
    data(){
      return{
        RefundBtn:false,
        ordersDetail:'',
        ordersNum:'',
        ordersTime:'',
        ordersData:{},
        name:'  ',
        phone:'  ',
        postcode:'',
        address:'',
        payment: ' ',//支付方式
        paymentRadio: 1,//支付方式
        invoice:'电子普通发票',
        tableData:[],
        goodsNumber:0,
        goodsPrice:0,
        freight: 0,
        device: 1,//1pc,2mob设备
        alipay:'',
        timer:'',
        multipleSelection: [],
        ordersId:''
      }
    },
    methods:{
      handleSelectionChange(val){//选择行
        this.multipleSelection=val
      },
      Refund(){//退款
        this.RefundBtn=true;
        if (!this.$store.state.isLogin) {
          this.$router.push({path: "/login"});
        }
        order_refund({id:this.ordersId}).then((res)=>{
          if(res.data.code==200){
            this.$message.success(res.data.message);
            this.getordersdata(this.ordersId)
          }else if(res.data.code==100){
            this.RefundBtn=false;
            this.$message.error(res.data.message);
          }
        })
      },
      getordersdata(order_id){
        if (!this.$store.state.isLogin) {
          this.$router.push({path: "/login"});
        }
        orders_i_url({id:order_id}).then((res)=>{
            this.ordersData=res.data.data;
            console.log(this.ordersData)
               if(this.ordersData.pay_method==1){
                this.payment='微信支付'
                }else if(this.ordersData.pay_method==2){
                this.payment='支付宝支付'
                }
                if(this.ordersData.order_status==1){
                this.ordersDetail='待付款'
                }else if(this.ordersData.order_status==2){
                this.ordersDetail='待收货'
                }else if(this.ordersData.order_status==3){
                this.ordersDetail='已完成'
                }else if(this.ordersData.order_status==4){
                this.ordersDetail='已取消'
                }else if(this.ordersData.order_status==6){
                this.ordersDetail='已退款'
                }else if(this.ordersData.order_status==7){
                this.ordersDetail='售后中'
                }
                this.ordersNum=this.ordersData.order_num
                this.freight=(+ this.ordersData.freight).toFixed(2)
                this.goodsPrice=(+ this.ordersData.total_price).toFixed(2)
                this.ordersTime=this.ordersData.order_time
                this.name=this.ordersData.address_info.recipients
                this.phone=this.ordersData.address_info.phone
                this.postcode=this.ordersData.address_info.postcode
                this.address=this.ordersData.address_info.sheng+this.ordersData.address_info.shi+this.ordersData.address_info.xian+this.ordersData.address_info.area
                this.tableData=this.ordersData.product
                for (var n = 0; n < this.tableData.length; n++) {
                this.goodsNumber += parseInt(this.tableData[n].num);
                this.p_key+=this.tableData[n].id+',';
                this.p_id+=this.tableData[n].p_id+',';
                this.num+=this.tableData[n].num+',';
                this.specs+=JSON.stringify(this.tableData[n].specs)+';';
                }
        })
       
     
      },
     topay(){
        if (!this.$store.state.isLogin) {
          this.$router.push({path: "/login"});
        }
        payOrder_url({order_num:this.ordersNum,pay_method:this.paymentRadio,device:this.device}).then((res)=>{
            let response_orders = res.data
                 this.$cookies.set('orders_data',response_orders.data);
                if (this.paymentRadio == 1) {
                if(this.device==1){
                    this.$router.push({path: '/Pay'});
                }else if(this.device==2){
                    window.location.href = response_orders.data.url
                    this.timer = setInterval(()=>{
                      this.getordersdata(this.ordersId)
                    },2000)
                }
                } else if (this.paymentRadio == 2) {
                  if (response_orders.code === 200) {
                      this.alipay = response_orders.data;
                      this.$nextTick(()=>{
                        document.forms['alipay_submit'].submit()
                      })
                  }
                }
        })
   
      },
    },
    mounted() {
      if (!this.$store.state.isLogin) {
        this.$router.push({path: "/login"});
      }

      //设备
      var sUserAgent = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        //移动端
        this.device=2;
      } else {
        //pc端
        this.device=1;
      }

      // if(decodeURIComponent((new RegExp('[?|&]id=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) == ''){
      if(!this.$route.query.id){
         if(this.$route.params.id){
          this.ordersId=this.$route.params.id
        }else{
          if(this.$cookies.isKey('ordersId')){
            this.ordersId=this.$cookies.get('ordersId')
            this.getordersdata(this.ordersId)
          }else {
            this.$router.push({path:'/Information',query:{id:'orderslist'}})
          }
        }
      }else {
         // this.ordersId=decodeURIComponent((new RegExp('[?|&]id=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20'))
        this.ordersId=this.$route.query.id
        if(this.ordersId){
          this.getordersdata(this.ordersId)
        }else{
          this.$router.push({path:'/Information',query:{id:'orderslist'}})
        }
        
      }
    },
    beforeDestroy() {
      clearInterval(this.timer);
    }
  }

</script>

<style lang="less" scoped>
/deep/.el-table__fixed-right::before, .el-table__fixed::before{
  background-color: #00383f;
}
/deep/.el-checkbox__inner::after{
  border: 1px solid #007177;
  border-top: 0;
  border-left: 0;
}
/deep/.el-radio__input.is-checked+.el-radio__label {
    color: #00383F;
}
/deep/.el-radio{
    color: #00383F;
}
/deep/.el-radio__inner{
    border:1px solid #00383F;
    background-color:unset;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
    border-color: #00383F;
    background: #00383F;
}
.orders_i .contain .Xcontainer .orderdata tr{
    border-bottom: 1px solid #00383F;
}
  .orders_i{
      .contain{
        width: 100%;
        color: #00383F;
        // min-height:calc(100vh - 300px);
           .Xcontainer{
               max-width: 1300px;
               margin: 0 auto;
               width: 85%;
               min-height:calc(100vh - 300px);
                .el-radio{display: inline-block;}
                .el-radio__inner:hover {
                    border-color: #00383F
                }

                .el-radio__input.is-checked + .el-radio__label {
                    color: #00383F;
                }

                .el-radio__input.is-checked .el-radio__inner {
                    border-color: #00383F;
                    background: #00383F;
                }
                .payment img {
                    width: 34px;
                    margin-right: 6px;
                        vertical-align: middle;
                }

                .cover{max-width: 120px;}
                text-align: left;
                i{font-style: normal;}
                h4{
                    font-size: 22px;
                    padding: 50px 0 20px;
                    font-weight: normal;
                    border-bottom: 1px solid #00383F;
                    padding-bottom: 15px;
                    a{color: #00383F;}
                }
                .ok{
                    display: flex;
                    align-items: center;
                    margin: 20px 0;
                    img{max-width: 80px;    vertical-align: middle;}
                    div{
                    display: inline-block;
                    padding-left: 10px;
                    h4{margin: 0;border-bottom: 0;padding: 0;}
                    span{margin-right: 30px;display: inline-block;}
                    }
                }

                .el-icon-download{
                    margin-left: 15px;
                    cursor: pointer;
                }

                .orderdata{
                 
                    // td{text-align: justify;text-align-last: justify; padding: 52px 0 0 15px; font-size: 15px; font-weight: 600;;}
                    td{
                        display: inline-block;
                        padding: 2% 0 15px 0;
                        font-size: 18px;
                    }
                    table{
                        width: 100%;
                        padding: 0 70%;
                        border-collapse:collapse;
                    }
                }
                .orders{
                    h5{
                    padding: 10px 0;
                    font-size: 18px;
                    font-weight: normal;
                    margin: 20px 0 0 0;
                    font-size: 20px;
                    }

                    .el-table td, .el-table th.is-leaf {
                    border-bottom-color: #00383F;
                    }

                    .el-table__fixed-right::before,
                    .el-table__fixed::before,
                    .el-table--border::after,
                    .el-table--group::after,
                    .el-table::before {
                    background-color: #00383F;
                    }

                    .el-table td {
                    padding: 0;
                    }

                    .el-table td, .el-table th {
                    text-align: center;
                    }

                    .el-table, .el-table thead {
                    color: #222;
                    }

                    .el-radio__inner:hover {
                    border-color: #333
                    }

                    .el-radio__input.is-checked + .el-radio__label {
                    color: #333;
                    }

                    .el-radio__input.is-checked .el-radio__inner {
                    border-color: #555;
                    background: #555;
                    }

                    .el-dialog__headerbtn:focus .el-dialog__close,
                    .el-dialog__headerbtn:hover .el-dialog__close {
                    color: #00383F;
                    font-weight: bold;
                    }

                    .el-button,
                    .el-button:focus,
                    .el-button:hover,
                    .el-button--primary {
                    background-color: #00383F;
                    border-color: #00383F;
                    border-radius: 0;
                    color: #fff;
                    }

                    .el-button{
                      background-color: transparent;
                      color: #00383F;
                      padding-left: .1rem;
                      padding-right: .1rem;
                    }

                    .submit_box {
                    overflow: hidden;
                    margin: 50px 0;
                    }

                    .submit_box > * {
                    float: right;
                    font-size: 18px;
                    height: 100%;
                    display: inline-block;
                    padding: 10px 30px;
                    }

                    .submit {
                    background-color: #00383F;
                    color: #fff;
                    cursor: pointer;
                    }
                }
                }
                }
   
  }
 @media (max-width: 991px) {
   .refund{margin-right:.8rem; border:1px solid #00383F; background-color: transparent; color: #00383F;}
   .refund:hover,.refund:focus{ background-color: #00383F; color: #fff;}
   .ordersmob{
     overflow: hidden;
    font-weight: bold;
      .citybox{
        margin: 0.4rem  0.3rem;
        height: 1.7rem;
        border: 1px solid #00383F;
        overflow: hidden;
      
        p{
          // max-width: 4.7rem;
          margin-top: 0.59rem;
          float: left;
          font-size: 0.28rem;
          text-align: left;
          margin-left: 0.28rem;
          margin-right: 0.28rem;
        }
      }
       .allorder{
          overflow: hidden;
          padding: 0.6rem 0.8rem;
          //  padding: 0 0.8rem;
          display: flex;
          .orderlft{
            width:23%;
            float: left;
            div{  
              width: 1.367rem;
              height: 2rem;
              background: url(../../static/mobile/product.png) no-repeat;
              background-size: 100% 100%;
              border: 1px solid #00383F ;
                img{
                width: 100%;
                padding-top: 0.27rem;
              }
            }
            span{
              display: inline-block;
              width: 100%;
              font-size: 0.19rem;
              text-align: left;
              margin-top: 0.3rem;
            }
          }
          .orderrig{
            width: 70%;
            float: left;
            text-align: left;
            margin-left: 7%;
            p{
              font-size: 0.24rem;
              font-weight: bold;
              color: #00383F;
            }
            p:nth-child(1){
              font-size: 0.3rem;
              padding-top: 0.19rem;
            }
              p:nth-child(2){
                padding: 0.32rem 0 0.3rem 0;
            }
            .btnbox{
              overflow: hidden;
              margin-top: 0.68rem;
              div{
                width: 1.2rem;
                height: 0.4rem;
                background: #00383F;
                color: #fff;
                text-align: center;
                line-height: 0.4rem;
                float: right;
                font-size: 0.22rem;
              }
              div:nth-child(2){
                margin-right: 0.3rem;
              }
            }
          }
  }
  .payMethod{
    text-align: left;
    h1{
      font-size: 0.3rem;
      margin: 0.8rem 0 0.59rem 0.8rem;
    }
    p{
      font-size: 0.24rem;
      margin-left: 0.8rem;
      margin-bottom: 1rem;
    }
    p:nth-child(2){
        margin-bottom: 0.6rem;      
    }
    .payment{
      margin-left: 0.8rem;
        /deep/.el-radio__inner{
    width: 0.21rem;
    height: 0.21rem;
    
  }
  /deep/.el-radio-group{
    margin-bottom: 0.9rem;
  }
  /deep/.el-radio__inner::after{
    width: 0.1rem!important;
    height: 0.1rem!important;
  }
  /deep/.el-radio__label{
      font-size: 0.24rem!important;
      height: 0.32rem!important;
      display: inline-block;
      line-height: 0.32rem;
      font-weight: bold;
     vertical-align: middle;
      img{
        margin: 0 0.09rem 0 0.13rem;
      }
  }
    }
  }
  .orderbto,.orderbtos{
    margin: 2rem 0.3rem 1rem 0.3rem;
    margin-top: 2rem;
    p{
      font-size: 0.3rem;
      margin-bottom: 0.4rem;
    }
    a,span{
      display: inline-block;
      width: 100%;
      height: 0.9rem;
      line-height: 0.9rem;
      background: #00383F;
      color: #fff;
      font-size: 0.36rem;
    }
  }

   }

 }
</style>



// WEBPACK FOOTER //
// src/view/Orders_i.vue